import { render, staticRenderFns } from "./UbsXmlExport.vue?vue&type=template&id=44a58ba9&scoped=true"
import script from "./UbsXmlExport.vue?vue&type=script&lang=js"
export * from "./UbsXmlExport.vue?vue&type=script&lang=js"
import style0 from "./UbsXmlExport.vue?vue&type=style&index=0&id=44a58ba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a58ba9",
  null
  
)

export default component.exports